import { Button } from "@/components/ui/button";
import { useServicesContent } from "@/hooks/useServicesContent";
import { Skeleton } from "@/components/ui/skeleton";

interface AdditionalServicesProps {
  onSchedule: (serviceType: string) => void;
}

export function AdditionalServices({ onSchedule }: AdditionalServicesProps) {
  const { content, loading } = useServicesContent("additional_services");
  
  if (loading) {
    return (
      <div className="bg-gray-50 p-8 rounded-lg">
        <Skeleton className="h-8 w-64 mx-auto mb-8" />
        <div className="grid md:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-white p-6 rounded-lg space-y-4">
              <Skeleton className="h-6 w-48" />
              <Skeleton className="h-20 w-full" />
              <Skeleton className="h-10 w-32" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const additionalServices = content
    .filter(item => item.is_active)
    .map(item => item.content_value);

  return (
    <div className="bg-gray-50 p-8 rounded-lg">
      <h2 className="text-3xl font-bold text-brand-primary mb-8 text-center">
        Serviços Adicionais
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {additionalServices.map((service, index) => (
          <div key={index} className="bg-white p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-3 font-accent">{service.title}</h3>
            <p className="font-text text-gray-600 mb-4">
              {service.description}
            </p>
            <Button 
              variant="outline" 
              className="border-brand-primary text-brand-primary hover:bg-brand-primary/5"
              onClick={() => onSchedule(service.serviceType)}
            >
              {service.buttonText}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
